import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Tree, Input} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$cc(Input, {
            'placeholder': 'Please enter keywords to filter node.',
            'ev-$model:value': function($v) {
                $this.set('keywords', $v);
            },
            'value': $this.get('keywords')
        }),
        _$cc(Tree, {
            'data': this.get('data'),
            'filter': this.filter,
            'ev-$model:expandedKeys': function($v) {
                $this.set('expandedKeys', $v);
            },
            'expandedKeys': $this.get('expandedKeys')
        })
    ], 4);
};